import { ScheduleType } from "Data/Objects/System";
import type { ScheduleSettingsState, SystemInformation } from "Interfaces";

export const DUMMY_SYSTEM_INFORMATION: SystemInformation = {
	dns1: "10.1.3.23",
	dns2: "0.0.0.0",
	firmwareVersion: "89100.1.0057.100",
	gateway: "10.1.6.1",
	httpPort: 80,
	ipAddress: "10.1.6.122",
	macAddress: "C4:A1:0E:B0:AA:AD",
	model: "CE-VX80ARSW5C",
	rtspPort: 554,
	serialNumber: "Not Used",
	subnetMask: "255.255.255.0",
	sdCardCapacity: 116.41,
	sdCardUsage: 29.07,
	httpsPort: 443
};

export const DUMMY_SCHEDULE_SETTINGS: ScheduleSettingsState = {
	schedules: [
		{
			name: "always",
			scheduleType: ScheduleType.DAILY,
			scheduledDay: {
				MON: true,
				TUE: true,
				WED: true,
				THU: true,
				FRI: true,
				SAT: true,
				SUN: true
			},
			startTime: "00:00",
			endTime: "00:00"
		},
		{
			name: "weekday",
			scheduleType: ScheduleType.WEEKLY,
			scheduledDay: {
				MON: true,
				TUE: true,
				WED: true,
				THU: true,
				FRI: true,
				SAT: true,
				SUN: true
			},
			startTime: "MON. 00:00",
			endTime: "SAT. 00:00"
		},
		{
			name: "weekend",
			scheduleType: ScheduleType.WEEKLY,
			scheduledDay: {
				MON: true,
				TUE: true,
				WED: true,
				THU: true,
				FRI: true,
				SAT: true,
				SUN: true
			},
			startTime: "SAT. 00:00",
			endTime: "MON. 00:00"
		}
	]
};
